import { z } from 'zod'

export const validateNumericString = (value: string) => z.coerce.number().safeParse(value)
